import _objectSpread from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import request from "@/utils/request";
import Interface from "@/utils/interface";
var api = {
  install: function install(Vue) {
    Vue.prototype.$api = this;
  }
};
Interface.forEach(function (v) {
  if (!v.desc) {
    console.error("你的方法没有添加描述信息！");
    return;
  }
  api[v.name] = function (params) {
    var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isLoading) {}

    // 过滤空参数
    if (params && JSON.stringify(params) !== "{}") {
      var arr = Object.keys(params);
      arr.forEach(function (item) {
        if (params[item] === null || params[item] === undefined) {
          delete params[item];
        }
      });
    }
    var path = v.path,
      method = v.method;
    var options;
    if (path == "/system/team/preview-auth") {
      options = {
        url: path,
        method: method,
        headers: {
          "Content-Type": "application/json; application/octet-stream"
        },
        responseType: "blob" //在请求中加上这一行，特别重要
      };
    } else {
      options = {
        url: path,
        method: method
      };
    }
    if (method.toLowerCase() == "get") {
      options = _objectSpread(_objectSpread({}, options), {}, {
        params: params
      });
    } else {
      options = _objectSpread(_objectSpread({}, options), {}, {
        data: params
      });
    }
    return request(options);
  };
});
export default api;